"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyWebChatButtonWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var StickyWebChatButtonWidget = /** @class */ (function (_super) {
    __extends(StickyWebChatButtonWidget, _super);
    function StickyWebChatButtonWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadWebChatScript = function () {
            var product = _this.getSetting("product");
            if (product) {
                var provider = _this.isContentGuruEnabled() ? "content-guru" : "genesys";
                var scriptPath = "/".concat(provider, "-web-chat-script-").concat(product, ".js");
                var otherProduct = "motor";
                if (product === "motor")
                    otherProduct = "home";
                var otherScriptPath = "/".concat(provider, "-web-chat-script-").concat(otherProduct, ".js");
                var otherScript = document.querySelector("script[src=\"".concat(otherScriptPath, "\"]"));
                // This reload is needed for edge case when we get motor policy first and then try to get
                // home quote from dashboard resulting in two instances of web chat (motor+home)
                if (otherScript) {
                    window.location.reload();
                }
                // Check if the script is already loaded
                if (!document.querySelector("script[src=\"".concat(scriptPath, "\"]"))) {
                    _this.webChatScript = document.createElement("script");
                    _this.webChatScript.src = scriptPath;
                    _this.webChatScript.async = true;
                    if (provider === "genesys") {
                        _this.webChatScript.onload = function () {
                            if (typeof window.Genesys === "function") {
                                window.Genesys("init");
                            }
                            else {
                                console.error("Genesys is not defined in the local script.");
                            }
                        };
                    }
                    document.head.appendChild(_this.webChatScript);
                }
            }
            else {
                console.log("Web-chat script not available");
            }
        };
        _this.handleBackNavigation = function (event) {
            // Reload the entire page
            if (window.location.href.includes("/products")) {
                window.location.reload();
            }
        };
        return _this;
    }
    StickyWebChatButtonWidget.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('popstate', function (ev) { return _this.handleBackNavigation(ev); });
        this.loadWebChatScript();
    };
    StickyWebChatButtonWidget.prototype.componentWillUnmount = function () {
        var _this = this;
        window.removeEventListener('popstate', function (ev) { return _this.handleBackNavigation(ev); });
    };
    StickyWebChatButtonWidget.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    StickyWebChatButtonWidget.prototype.isContentGuruEnabled = function () {
        return process.env.REACT_APP_CONTENT_GURU_ENABLED ? JSON.parse(process.env.REACT_APP_CONTENT_GURU_ENABLED) : false;
    };
    ;
    StickyWebChatButtonWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "product", type: journey_model_1.TypeDescriptions.String }
        ])
    ], StickyWebChatButtonWidget);
    return StickyWebChatButtonWidget;
}(plugin_journey_1.WidgetBase));
exports.StickyWebChatButtonWidget = StickyWebChatButtonWidget;
//# sourceMappingURL=StickyWebChatButtonWidget.js.map